import React, { useEffect, useState, useRef } from "react";
import {
  Box,
  Typography,
  CardMedia,
  Stack,
  Chip,
  CircularProgress,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Avatar,
  Divider,
  DialogContentText,
  TextField,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { fetchOfferDetailsById } from "../../../../../../../../services/pos/Tables";
import { useProductsOffers } from "../../../../../../../../context/OrderCreator/ProductContext";
import { useOrder } from "../../../../../../../../context/OrderCreator/TablesContext/OrderContext";



const ActiveOffersList = ({ orderId: propOrderId, onOfferAdded }) => {
  const [offers, setOffers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const scrollBoxRef = useRef(null);

  const [offerDetailsOpen, setOfferDetailsOpen] = useState(false);
  const [offerDetails, setOfferDetails] = useState(null);
  const [detailsLoading, setDetailsLoading] = useState(false);

  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const [offerToAdd, setOfferToAdd] = useState(null);
  const [offerQuantity, setOfferQuantity] = useState(1);
  const [successDialogOpen, setSuccessDialogOpen] = useState(false);
  const successDialogTimer = useRef();
  const { addOffer, loadOrder } = useOrder();




  const orderId = propOrderId || localStorage.getItem("order_id");
    const { offers: ctxOffers, loading: ctxLoading, error: ctxError } = useProductsOffers();


const handleAddOffer = async (offer_id, offer_name) => {
  if (!orderId) {
    alert("لم يتم تحديد الطلب.");
    return;
  }

  try {
    await addOffer({ offer_id, order_id: orderId, quantity: Number(offerQuantity) || 1 });
    await loadOrder(orderId);
    setConfirmDialogOpen(false);
    setSuccessDialogOpen(true);
    setOfferQuantity(1);

    clearTimeout(successDialogTimer.current);
    successDialogTimer.current = setTimeout(() => {
      setSuccessDialogOpen(false);
    }, 750);
  } catch (err) {
    setConfirmDialogOpen(false);
    alert(err.message || "❌ فشل في إضافة العرض للطلب");
  }
};


  useEffect(() => {
    // خذ العروض من الـ ProductContext
    // إذا كانت الدالة useProducts تُستخدم مباشرة داخل effect ستؤدي لمشكلات (Hook inside effect) --
    // لذلك نقرأ القيم عبر استدعاء useProducts خارج الـ effect. هنا نزامن state محلي مع القيم من الـ context.
    setOffers((prev) => (Array.isArray(ctxOffers) ? ctxOffers : prev));
    setLoading(Boolean(ctxLoading));
    setError(ctxError ? (ctxError.message || String(ctxError)) : null);
  }, []);

  useEffect(() => {
    return () => {
      clearTimeout(successDialogTimer.current);
    };
  }, []);

  const subdomain = window.location.hostname.split(".")[0];
  const IMAGE_BASE_URL = `https://${subdomain}.restocash.app/`;

  const handleScrollDown = () => {
    if (scrollBoxRef.current) {
      scrollBoxRef.current.scrollTop = scrollBoxRef.current.scrollHeight;
    }
  };

  
  const handleShowOfferDetails = async (offerId) => {
    setDetailsLoading(true);
    setOfferDetailsOpen(true);
    try {
      const details = await fetchOfferDetailsById(offerId);
      setOfferDetails(details);
    } catch (err) {
      setOfferDetails({ error: err.message });
    } finally {
      setDetailsLoading(false);
    }
  };

  if (loading) return <CircularProgress color="primary" />;
  if (error) return <Typography color="error">❌ {error}</Typography>;

  return (
    <Box
      sx={{
        p: 1,
        maxHeight: 370,
        height: 370,
        overflowY: "auto",
        position: "relative",
        scrollbarWidth: "none",
        "&::-webkit-scrollbar": { display: "none" },
        borderRadius: 4,
        background: "linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)",
        boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
      }}
      ref={scrollBoxRef}
    >
      {offers.length === 0 && (
        <Typography sx={{ color: "rgba(255,255,255,0.5)", textAlign: "center", py: 4 }}>
          لا توجد عروض حالية.
        </Typography>
      )}

      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))",
          gap: 2.5,
        }}
      >
        {offers.map((offer) => (
          <Box
            key={offer.id}
            onClick={() => {
              if (!orderId) {
                alert("لم يتم تحديد الطلب.");
                return;
              }
              setOfferToAdd(offer);
              setConfirmDialogOpen(true);
            }}
            sx={{
              position: "relative",
              borderRadius: 4,
              overflow: "hidden",
              boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
              bgcolor: "#1a1a2e",
              border: "1px solid rgba(255,255,255,0.05)",
              minHeight: 180,
              cursor: "pointer",
              transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
              "&:hover": {
                boxShadow: "0 12px 40px rgba(251, 194, 235, 0.25)",
                transform: "translateY(-8px) scale(1.02)",
                border: "1px solid rgba(251, 194, 235, 0.3)",
                background: "linear-gradient(135deg, #1a1a2e 0%, rgba(251, 194, 235, 0.08) 100%)",
              },
              display: "flex",
              flexDirection: "column",
              justifyContent: "flex-end",
            }}
          >
            <CardMedia
              component="img"
              image={
                offer.image
                  ? `${IMAGE_BASE_URL}${offer.image}`
                  : "https://via.placeholder.com/300x140?text=Offer"
              }
              alt={offer.name}
              sx={{
                width: "100%",
                height: 140,
                objectFit: "cover",
                display: "block",
                filter: "brightness(0.75) contrast(1.1)",
                borderTopLeftRadius: 4,
                borderTopRightRadius: 4,
                transition: "all 0.3s ease",
              }}
            />

            <Box
              sx={{
                position: "absolute",
                left: 0,
                right: 0,
                bottom: 0,
                p: 2.5,
                pb: 2,
                color: "#fff",
                background: "linear-gradient(0deg, rgba(26,26,46,0.95) 70%, rgba(26,26,46,0.7) 85%, rgba(26,26,46,0) 100%)",
                backdropFilter: "blur(4px)",
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                minHeight: 140,
                borderBottomLeftRadius: 4,
                borderBottomRightRadius: 4,
                boxShadow: "0 -4px 20px rgba(0,0,0,0.3)",
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", width: "100%", mb: 1 }}>
                <Typography
                  sx={{
                    fontWeight: 700,
                    fontSize: "1.15rem",
                    flex: 1,
                    color: "#fff",
                    textShadow: "0 2px 8px rgba(0,0,0,0.6)",
                    letterSpacing: "0.3px",
                  }}
                >
                  {offer.name}
                </Typography>
                <Chip
                  label={`خصم: ${offer.discount}%`}
                  size="small"
                  sx={{
                    bgcolor: "rgba(76, 175, 80, 0.2)",
                    color: "#81c784",
                    fontWeight: 600,
                    fontSize: 12,
                    borderRadius: 2,
                    border: "1px solid rgba(76, 175, 80, 0.3)",
                  }}
                />
                <Chip
                  label={`${offer.total_price} ج.م`}
                  size="small"
                  sx={{
                    bgcolor: "rgba(251, 194, 235, 0.2)",
                    color: "#fbc2eb",
                    fontWeight: 700,
                    fontSize: 12,
                    borderRadius: 2,
                    border: "1px solid rgba(251, 194, 235, 0.3)",
                  }}
                />
              </Box>
              <Typography variant="caption" sx={{ color: "rgba(255,255,255,0.7)", mb: 1, fontSize: 13, lineHeight: 1.4 }}>
                {offer.description}
              </Typography>
              <Stack direction="row" spacing={1} sx={{ mb: 1 }}>
                <Chip
                  label={`كود: ${offer.code}`}
                  size="small"
                  sx={{
                    bgcolor: "rgba(255,255,255,0.15)",
                    backdropFilter: "blur(8px)",
                    color: "#232334",
                    fontWeight: 600,
                    fontSize: 12,
                    borderRadius: 2,
                    border: "1px solid rgba(255,255,255,0.2)",
                  }}
                />
              </Stack>
              <Box sx={{ width: "100%" }}>
                <Typography variant="caption" sx={{ color: "rgba(255,255,255,0.8)", fontWeight: 600, fontSize: 12, mb: 0.5 }}>
                  الأصناف:
                </Typography>
                <Stack direction="row" spacing={1} mt={0.5} flexWrap="wrap">
                  {offer.itmes?.map((item) => (
                    <Box
                      key={item.id}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        bgcolor: "rgba(255,255,255,0.08)",
                        backdropFilter: "blur(8px)",
                        border: "1px solid rgba(255,255,255,0.1)",
                        borderRadius: 3,
                        px: 1.5,
                        py: 0.5,
                        mr: 1,
                        mb: 0.5,
                        minWidth: 0,
                        maxWidth: 180,
                        transition: "all 0.2s ease",
                        "&:hover": {
                          bgcolor: "rgba(251, 194, 235, 0.15)",
                          border: "1px solid rgba(251, 194, 235, 0.3)",
                        },
                      }}
                    >
                      <CardMedia
                        component="img"
                        image={
                          typeof item.product_image === "string"
                            ? `${IMAGE_BASE_URL}${item.product_image}`
                            : item.product_image?.image
                              ? `${IMAGE_BASE_URL}${item.product_image.image}`
                              : "https://via.placeholder.com/40"
                        }
                        alt={item.product_name}
                        sx={{ width: 28, height: 28, borderRadius: 2, mr: 1, objectFit: "cover" }}
                      />
                      <Typography
                        variant="body2"
                        sx={{
                          color: "#fff",
                          fontSize: 13,
                          fontWeight: 600,
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          flex: 1,
                        }}
                      >
                        {item.product_name} × {item.quantity}
                      </Typography>
                    </Box>
                  ))}
                </Stack>
              </Box>
              <Box
                sx={{
                  position: "absolute",
                  left: 16,
                  bottom: 16,
                  display: "flex",
                  gap: 1.5,
                  zIndex: 50,
                }}
              >
                <IconButton
                  sx={{
                    bgcolor: "rgba(255,255,255,0.1)",
                    backdropFilter: "blur(8px)",
                    color: "#fff",
                    width: 36,
                    height: 36,
                    border: "1px solid rgba(255,255,255,0.2)",
                    transition: "all 0.3s ease",
                    "&:hover": {
                      bgcolor: "rgba(251, 194, 235, 0.2)",
                      border: "1px solid rgba(251, 194, 235, 0.5)",
                      transform: "scale(1.1)",
                    },
                  }}
                  onClick={async (e) => {
                    e.stopPropagation();
                    await handleShowOfferDetails(offer.id);
                  }}
                >
                  <VisibilityIcon fontSize="small" />
                </IconButton>
                <IconButton
                  sx={{
                    background: "linear-gradient(135deg, #fbc2eb 0%, #ff9a9e 100%)",
                    color: "#232334",
                    width: 36,
                    height: 36,
                    boxShadow: "0 4px 12px rgba(251, 194, 235, 0.4)",
                    transition: "all 0.3s ease",
                    "&:hover": {
                      background: "linear-gradient(135deg, #ff9a9e 0%, #fbc2eb 100%)",
                      transform: "scale(1.1) rotate(5deg)",
                      boxShadow: "0 6px 20px rgba(251, 194, 235, 0.6)",
                    },
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    setOfferToAdd(offer);
                    setConfirmDialogOpen(true);
                  }}
                >
                  <AddIcon fontSize="small" />
                </IconButton>
              </Box>
            </Box>
          </Box>
        ))}
      </Box>

      {/* مودال تأكيد إضافة العرض */}
      <Dialog
        open={confirmDialogOpen}
        onClose={() => setConfirmDialogOpen(false)}
        maxWidth="xs"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 4,
            background: "linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)",
            border: "1px solid rgba(251, 194, 235, 0.2)",
          },
        }}
      >
        <DialogTitle sx={{ fontWeight: 700, color: "#fbc2eb" }}>تأكيد إضافة العرض</DialogTitle>
        <DialogContent>
          <DialogContentText sx={{ color: "rgba(255,255,255,0.8)" }}>
            هل أنت متأكد من إضافة العرض التالي للطلب؟
          </DialogContentText>
          <Box sx={{ mt: 3, display: "flex", gap: 1, alignItems: "center", justifyContent: "center" }}>
            <TextField
              label="الكمية"
              type="number"
              inputProps={{ min: 1 }}
              value={offerQuantity}
              onChange={(e) => setOfferQuantity(Math.max(1, Number(e.target.value || 1)))}
              size="small"
              sx={{
                width: 140,
                "& .MuiOutlinedInput-root": {
                  bgcolor: "rgba(255,255,255,0.05)",
                  color: "#fff",
                  "&:hover fieldset": { borderColor: "#fbc2eb" },
                  "&.Mui-focused fieldset": { borderColor: "#fbc2eb" },
                },
                "& .MuiInputLabel-root": { color: "rgba(255,255,255,0.7)" },
              }}
            />
          </Box>
          <Typography variant="h6" sx={{ mt: 3, textAlign: "center", color: "#fff", fontWeight: 700 }}>
            {offerToAdd?.name}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setConfirmDialogOpen(false)}
            sx={{
              color: "rgba(255,255,255,0.7)",
              "&:hover": { bgcolor: "rgba(255,255,255,0.05)" },
            }}
          >
            إلغاء
          </Button>
          <Button
            onClick={() => handleAddOffer(offerToAdd.id, offerToAdd.name)}
            variant="contained"
            sx={{
              background: "linear-gradient(135deg, #fbc2eb 0%, #ff9a9e 100%)",
              color: "#232334",
              fontWeight: 700,
              "&:hover": {
                background: "linear-gradient(135deg, #ff9a9e 0%, #fbc2eb 100%)",
              },
            }}
          >
            نعم، إضافة العرض
          </Button>
        </DialogActions>
      </Dialog>

      {/* مودال نجاح الإضافة */}
      <Dialog
        open={successDialogOpen}
        onClose={() => setSuccessDialogOpen(false)}
        maxWidth="xs"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 4,
            background: "linear-gradient(135deg, #1a1a2e 0%, rgba(76, 175, 80, 0.1) 100%)",
            border: "1px solid rgba(76, 175, 80, 0.3)",
          },
        }}
      >
        <DialogTitle sx={{ fontWeight: 700, color: "#81c784" }}>✓ تمت الإضافة بنجاح</DialogTitle>
        <DialogContent>
          <DialogContentText sx={{ textAlign: "center", fontWeight: 600, color: "#fff" }}>
            تم إضافة العرض <span style={{ color: "#fbc2eb" }}>{offerToAdd?.name}</span> للطلب بنجاح.
          </DialogContentText>
        </DialogContent>
        {/* لا تعرض زر إغلاق */}
      </Dialog>

      <Dialog open={offerDetailsOpen} onClose={() => setOfferDetailsOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>تفاصيل العرض</DialogTitle>
        <DialogContent>
          {detailsLoading ? (
            <Box sx={{ textAlign: "center", py: 4 }}>
              <CircularProgress color="primary" />
            </Box>
          ) : offerDetails && !offerDetails.error ? (
            <Box>
              <Typography variant="h6" fontWeight={700} mb={1}>
                {offerDetails.name}
              </Typography>
              <Typography variant="body2" color="text.secondary" mb={1}>
                {offerDetails.description}
              </Typography>
              <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                <Avatar
                  src={
                    offerDetails.image
                      ? `${IMAGE_BASE_URL}${offerDetails.image}`
                      : "https://via.placeholder.com/80x80?text=Offer"
                  }
                  alt={offerDetails.name}
                  sx={{ width: 80, height: 80, mr: 2 }}
                />
                <Box>
                  <Chip label={`كود: ${offerDetails.code}`} size="small" sx={{ mr: 1 }} />
                  <Chip label={`خصم: ${offerDetails.discount}%`} size="small" color="success" sx={{ mr: 1 }} />
                  <Chip label={`$${offerDetails.total_price}`} size="small" color="info" />
                </Box>
              </Box>
              <Typography variant="body2" mb={1}>
                <strong>الفترة:</strong> {offerDetails.start_date?.slice(0, 10)} إلى {offerDetails.end_date?.slice(0, 10)}
              </Typography>
              <Typography variant="body2" mb={1}>
                <strong>الحالة:</strong> {offerDetails.status}
              </Typography>
              <Divider sx={{ my: 2 }} />
              <Typography variant="subtitle2" mb={1}>الأصناف:</Typography>
              <Stack spacing={1}>
                {offerDetails.itmes?.map((item) => (
                  <Box key={item.id} sx={{ display: "flex", alignItems: "center" }}>
                    <Avatar
                      src={
                        item.product_image
                          ? `${IMAGE_BASE_URL}${item.product_image}`
                          : "https://via.placeholder.com/40"
                      }
                      alt={item.product_name}
                      sx={{ width: 40, height: 40, mr: 1 }}
                    />
                    <Typography variant="body2" sx={{ flex: 1 }}>
                      {item.product_name} × {item.quantity} = ${item.price}
                    </Typography>
                  </Box>
                ))}
              </Stack>
              <Divider sx={{ my: 2 }} />
              <Typography variant="subtitle2" mb={1}>الفروع المرتبطة:</Typography>
              <Stack direction="row" spacing={1}>
                {offerDetails.roots?.map((root) => (
                  <Chip key={root.id} label={root.name} color="primary" variant="outlined" />
                ))}
              </Stack>
            </Box>
          ) : (
            <Typography color="error">{offerDetails?.error || "فشل في تحميل تفاصيل العرض."}</Typography>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOfferDetailsOpen(false)} color="primary">
            إغلاق
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default ActiveOffersList;
